/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.19.0
 */

import {
    API_SUBSCRIBER_TABLE_BASKET_LIST,
    API_SUBSCRIBER_TABLE_CHECKBOX,
    API_SUBSCRIBER_TABLE_COLUMN_SETTINGS,
    API_SUBSCRIBER_TABLE_FILTER_AND_SORT,
    API_SUBSCRIBER_TABLE_FILTER_PRESET,
    API_SUBSCRIBER_TABLE_FILTER_SUGGEST,
    API_SUBSCRIBER_TABLE_LIST,
    API_SUBSCRIBER_TABLE_META,
    API_SUBSCRIBER_TABLE_RESIZE,
} from './constants';
import { tableSubscriberListenerMiddleware } from './middleware/tableSubscriberListenerMiddleware';

export {
    /* Subscriber Table Urls */
    API_SUBSCRIBER_TABLE_META,
    API_SUBSCRIBER_TABLE_LIST,
    API_SUBSCRIBER_TABLE_FILTER_AND_SORT,
    API_SUBSCRIBER_TABLE_FILTER_SUGGEST,
    API_SUBSCRIBER_TABLE_FILTER_PRESET,
    API_SUBSCRIBER_TABLE_CHECKBOX,
    API_SUBSCRIBER_TABLE_BASKET_LIST,
    API_SUBSCRIBER_TABLE_RESIZE,
    API_SUBSCRIBER_TABLE_COLUMN_SETTINGS,
    /* api middleware */
    tableSubscriberListenerMiddleware,
};
